import * as React from 'react';

import {IconOnlyButton} from 'shells/button/icon-only-button/icon-only-button';
// @ts-expect-error - imported from .js/.jsx file
import {EyeIcon} from 'shells/icon/svg/eye-icon';
// @ts-expect-error - imported from .js/.jsx file
import {LeadHotIcon} from 'shells/icon/svg/lead-hot-icon';

import type {GetLead_lead as Lead} from 'nutshell-graphql-types';

import {CustomizeLayoutButton} from '../../core-entity/layout-customizer/customize-layout-button';

type Props = {
    lead: Lead;
    userCanAccessSetup: boolean;
    onHotToggle: () => void;
    onWatchingToggle: () => void;
};

export function HeaderIconToggles(props: Props) {
    const isHot = props.lead.isHot;
    const isWatching = props.lead.isCurrentUserWatching;

    return (
        <>
            {NutClientConfig.hasHotLeads && (
                <IconOnlyButton
                    icon={LeadHotIcon}
                    onClick={props.onHotToggle}
                    isActive={isHot}
                    tooltipText={isHot ? 'Unmark as hot lead' : 'Mark as hot lead'}
                    size='large'
                    hasBorder={true}
                    variant='orange'
                />
            )}
            {NutClientConfig.hasLeadWatching && (
                <IconOnlyButton
                    icon={EyeIcon}
                    tooltipText={isWatching ? 'Stop watching this lead' : 'Watch this lead'}
                    onClick={props.onWatchingToggle}
                    isActive={isWatching}
                    size='large'
                    hasBorder={true}
                />
            )}
            {!NutClientConfig.hasCoreEntityFullHeightSidebarFF && props.userCanAccessSetup && (
                <CustomizeLayoutButton
                    text='Layout'
                    entityType='LEAD'
                    stagesetId={props.lead.stagesetForWidgets.id}
                />
            )}
        </>
    );
}
